import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$slug/settings/debug')({
  component: DebugPage,
})

function DebugPage() {
  return (
    <div className="space-y-4 py-6">
      <h1 className="text-2xl font-bold">Debug</h1>
      <p className="text-muted-foreground">Debug tools and information.</p>
    </div>
  )
}
